/** Component key for root install */
export const ROOT = "root";

/** Identifier of singleton install items
 */
export const SINGLETON_ITEM = "_";
